import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";

function* getGameEngines(action) {
    try {
        const gameEngines = yield call(() => gamesAPI.getGameEngines());

        yield put({
            type: GamesActionTypes.GET_GAME_ENGINES_SUCCESS,
            payload: {
                gameEngines: gameEngines.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game engine versions list.");

        yield put({
            type: GamesActionTypes.GET_GAME_ENGINES_FAIL,
            message: e.message
        });
    }
}

export function* getGameEnginesWatcher() {
    yield takeLatest(GamesActionTypes.GET_GAME_ENGINES, getGameEngines);
}

function* getEnginesSchemas(action) {
    try {
        const enginesSchemas = yield call(() =>
            gamesAPI.getGameEnginesSchemas()
        );

        yield put({
            type: GamesActionTypes.GET_GAME_ENGINES_SCHEMAS_SUCCESS,
            payload: {
                enginesSchemas: enginesSchemas.data.results
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game engine schemas.");

        yield put({
            type: GamesActionTypes.GET_GAME_ENGINES_SCHEMAS_FAIL,
            message: e.message
        });
    }
}

export function* getEnginesSchemasWatcher() {
    yield takeLatest(
        GamesActionTypes.GET_GAME_ENGINES_SCHEMAS,
        getEnginesSchemas
    );
}
